import styled from '@emotion/styled'
import { env } from 'src/utils/env'

export const Container = styled.div`
  .promo-footer {
    position: relative;
    background-color: #e5e0da;
    height: 405px;
  }

  .promo-footer__container {
    z-index: 1;
    position: relative;
    box-sizing: border-box;
    max-width: 1064px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    padding: 24px 16px;
  }

  .promo-footer__background {
    width: 100%;
    height: 180px;
    position: relative;
    max-width: 1440px;
    display: flex;
    background-image: url('${env
      .BASE_MAGNOLIA_IMAGING_URL}/dam/WEB/Pembiayaan-Tunai/pembiayaan-tunai-loyal-customer.png');
    background-position: center 0px;
    background-repeat: no-repeat;
    background-size: auto 192px;

    left: unset;
    transform: unset;
  }

  .promo-footer__greeting {
    display: flex;
    flex-direction: column;
    gap: 8px;
    padding: 0;
  }

  .promo-footer__button {
    margin-top: 16px;
  }

  .promo-footer__button .button {
    display: flex;
    justify-content: center;
    width: auto;
    height: 36px;
    font-family: Lexend;
    font-size: 12px;
    font-weight: 500;
    line-height: 32px;
    letter-spacing: 0.005em;
    text-align: center;
    padding: 6px 8px;
  }

  .promo-footer__downloads img {
    width: 138px;
    height: 40px;
  }

  @media only screen and (min-width: 480px) {
    .promo-footer {
      height: 313px;
    }

    .promo-footer__container {
      box-sizing: border-box;
      max-width: 1064px;
      height: 100%;
      margin: 0 auto;
      display: flex;
      flex-direction: column;
      padding: 16px;
    }

    .promo-footer__background {
      position: absolute;
      max-width: 1440px;
      display: flex;
      height: 100%;
      background-image: url('${env
      .BASE_MAGNOLIA_IMAGING_URL}/dam/WEB/Pembiayaan-Tunai/pembiayaan-tunai-loyal-customer.png');
      background-repeat: no-repeat;
      background-position: calc(100% - 16px) calc(100%);
      background-size: auto 100%;

      top: 0;
      left: 50%;
      transform: translateX(-50%);
    }

    .promo-footer__greeting {
      padding: 16px;
    }

    .promo-footer__button {
      margin: 16px 16px;
    }

    .promo-footer__button .button {
      display: flex;
      justify-content: center;
      width: 190px;
      height: 44px;
      font-family: Lexend;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: 0.005em;
      text-align: center;
      padding: 6px 8px;
    }

    .promo-footer__downloads {
      display: flex;
      flex-direction: row;
      gap: 16px;
      margin-left: 8px;
      margin-top: 6px;
    }

    .promo-footer__container {
      padding: 40px 0;
    }
  }
`
